<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">In Loving Memory of</p>
<p style="text-align: center;">Steven Thomas Brinkman</p>
<p style="text-align: center;"><img alt="" class="center" src="media/file1.png" style="width:2.99003in;height:2.93507in"/></p>
<p style="text-align: center;">October 15, 1967 to March 7, 2016</p><br/>
<p style="text-indent:0em;">Steven Brinkman was a very big, strong man. A great detective and a very good friend. We did a lot of work together over the years. It’s hard to lose a good friend.</p><br/>
<p style="text-align: center;">Gabe G. Kemling</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?c82b5202